'use strict';
import moment from 'moment-timezone';

import stringSimilarity from 'string-similarity'


angular.module('docketbook').
  controller('orderDetailController', function (orderService, addressBookService, resourceService, jobService, docketService, userService, xeroService, $rootScope, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation, $q) {

    // Main Variables For Doing Stuff
    $scope.moment = moment;
    $scope.itemEdit = null;

    $scope.docketsQuery = {
      limit: 10,
      page: 1,
      order: 'docketNumber'
    };
    $scope.docketsPromise = null;

    $scope.canChangeLineResources = false;

    $scope.jobsQuery = {
      limit: 10,
      page: 1,
      order: 'jobNumber'
    };
    $scope.jobsPromise = null;
    $scope.allFields = {};

    // Base Access Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentTab = "General";
    $scope.splitListFunc = new splitListInterface($scope, $stateParams);
    $scope.userCanDoAction = userService.userCanDoAction;

    if ($scope.currentOrg && $scope.currentOrg.features.canChangeOrderResources == true) {
      $scope.canChangeLineResources = true;
    }

    /***************************************/
    /***** Parent Controlled Functions *****/
    /***************************************/

    $scope.$parent.currentActiveTab = function () {
      return $scope.currentTab;
    }

    $scope.$parent.prepareForOrderFromParent = function (openTab, order) {
      $scope.itemEdit = {};
      $scope.itemEdit.loading = true;
      $scope.itemEdit.loadingType = "getting";
      if (order) {
        $scope.itemEdit.orderId = order;
      }
      if (order.orderNumber) {
        $scope.itemEdit.orderNumber = order.orderNumber;
      }
      if (openTab) {
        $scope.currentTab = openTab;
      } else {
        $scope.currentTab = "General";
      }
      if ($stateParams.device == 'mobile') {
        $timeout(function () {
          $scope.openMobileTab($scope.currentTab);
        }, 500);
      }
    }

    $scope.$parent.loadOrderFromParent = function (order) {
      $scope.itemEdit = order;
      // TODO change xeroQuote field to use externalId for xero quote id reference
      if (order.supplierRefNo) {
        var refNoSplit = order.supplierRefNo.split('_');
        if (refNoSplit.length > 0 && refNoSplit[0] == 'xq') {
          //refNoSplit.shift();
          //refNoSplit.shift();
          $scope.itemEdit.xeroQuote = true;
          $scope.itemEdit.xeroQuoteId = refNoSplit[2];
        }
      }
      $scope.itemEdit.loading = false;
      if ($stateParams.device == 'desktop') {
        $scope.itemEdit.editing = false;
      } else {
        if ($scope.userCanDoAction('editOrder', $scope.itemEdit)) {
          $scope.itemEdit.editing = true;
        } else {
          $scope.itemEdit.editing = false;
        }
      }
      if ($scope.currentOrg != null && $scope.currentOrgGroup != null) {
        $scope.loadOrderDockets($scope.itemEdit);
        //$scope.loadOrderCompletionRates($scope.itemEdit);
        $scope.loadOrderJobs($scope.itemEdit);
        if ($scope.itemEdit.xeroQuote == true || ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.enabled == true && $scope.currentOrg.planFeatures.accountingIntegrationEnabled == true)) {
          $scope.loadOrderXeroInfo($scope.itemEdit);
        }
      }
      $scope.updateTemplateFields($scope.itemEdit.template);
    }

    $scope.$parent.newOrderFromParent = function (prefillMethod, prefillData) {
      if (prefillMethod && prefillMethod == 'fromXeroQuote') {
        $scope.newOrderFromXeroQuote(prefillData);
      } else {
        $scope.newOrder(prefillMethod, prefillData);
      }
    }

    $scope.$parent.clearOrderFromParent = function () {
      $scope.itemEdit = null;
    }

    $scope.$parent.getOrderFromParent = function () {
      return $scope.itemEdit;
    }

    $scope.loadOrderXeroInfo = function (order) {
      // Load most recent full Xero Quote
      if (order.xeroQuoteId) {
        xeroService.getXeroQuote(order.xeroQuoteId, function (quote) {
          order.xeroQuoteFull = quote;
          // attached quote line reference to order lines
          for (var i = 0; i < order.lineItems.length; i++) {
            if (order.lineItems[i].supplierRef) {
              for (var j = 0; j < quote.lineItems.length; j++) {
                if ('xql-' + quote.lineItems[j].lineItemID == order.lineItems[i].supplierRef) {
                  // this is the correct quote line item
                  order.lineItems[i].xeroQuoteLineItem = quote.lineItems[j];
                  break;
                }
              }
            }
          }
        }, function (err) {
          console.error('could not get xero quote', err);
        });
      } else {
        // check if order has xero line items added to it
        var xeroItemIds = [];
        for (var i = 0; i < order.lineItems.length; i++) {
          if (order.lineItems[i].supplierRef) {
            var idSplit = order.lineItems[i].supplierRef.split('-');
            if (idSplit[0] == 'xi') {
              idSplit.shift();
              xeroItemIds.push(idSplit.join('-'));
            }
          }
        }
        if (xeroItemIds.length > 0) {
          xeroService.getXeroItems({ externalIds: xeroItemIds.join(',') }, function (xeroItems) {
            for (var i = 0; i < order.lineItems.length; i++) {
              if (order.lineItems[i].supplierRef && order.lineItems[i].supplierRef.split('-')[0] == 'xi') {
                for (var j = 0; j < xeroItems.length; j++) {
                  if ('xi-' + xeroItems[j].externalId == order.lineItems[i].supplierRef) {
                    order.lineItems[i].xeroLineItem = xeroItems[j];
                    break;
                  }
                }
              }
            }
          }, function (err) {
            console.error('could not get xero items', err);
          });
        }
      }
    }

    const loadDocketBlock = function (order, page) {
      var params = [];
      params['limit'] = 200
      params['offset'] = 200 * (page - 1)
      params['sort'] = $scope.docketsQuery.order;
      params['orderRef'] = order.id;

      docketService.getDockets(params, function (returnData) {
        var docketsListParsed = [];
        if (returnData != null) {
          docketsListParsed = docketService.parseDockets(returnData);
        }
        //order.dockets = docketsListParsed;

        order.dockets = order.dockets.concat(docketsListParsed)
        if (docketsListParsed.length >= 200) {
          loadDocketBlock(order, page + 1)
        } else {
          $scope.loadOrderCompletionRates(order)
        }
      })
    }

    $scope.loadOrderDockets = function (order) {
      order.dockets = []
      loadDocketBlock(order, 1)
    }

    $scope.loadOrderCompletionRates = function (order) {
      var dockets = order.dockets;
      var allDockets = dockets

      // summarise line data
      var lineTotals = {};
      for (var i = 0; i < order.lineItems.length; i++) {
        lineTotals[order.lineItems[i].id] = { quantity: 0, interactionBreakdown: {} };
      }
      for (var i = 0; i < allDockets.length; i++) {
        var thisDocket = allDockets[i];
        for (var j = 0; j < thisDocket.resources.length; j++) {
          var thisResource = thisDocket.resources[j];
          if (thisResource.orderItemId && lineTotals[thisResource.orderItemId]) {
            // go through interactions and sum quantities
            for (var k = 0; k < thisResource.interactions.length; k++) {
              var thisInteraction = thisResource.interactions[k];
              if (!lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name]) {
                lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name] = { quantity: 0, billable: thisInteraction.interactionTemplate.billable };
              }
              lineTotals[thisResource.orderItemId].interactionBreakdown[thisInteraction.interactionTemplate.name].quantity += thisInteraction.quantity;
              if (thisInteraction.interactionTemplate.billable == true) {
                lineTotals[thisResource.orderItemId].quantity += thisInteraction.quantity;
              }
            }
          }
        }
      }
      for (var i = 0; i < order.lineItems.length; i++) {
        lineTotals[order.lineItems[i].id].quantity = Math.round((lineTotals[order.lineItems[i].id].quantity + Number.EPSILON) * 100) / 100;
      }
      order.lineTotals = lineTotals;
      return;
    }

    $scope.$parent.loadOrderDocketsNextPage = function (cb) {
      var offsetPre = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      $scope.docketsQuery.page = $scope.docketsQuery.page + 1;
      var offset = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      // get next page of dockets from docketService using pagination query params
      var params = [];
      params['limit'] = $scope.docketsQuery.limit;
      params['offset'] = $scope.docketsQuery.limit * ($scope.docketsQuery.page - 1);
      params['sort'] = $scope.docketsQuery.order;
      params['orderRef'] = $scope.itemEdit.id;

      docketService.getDockets(params, function (returnData) {
        var docketsListParsed = [];
        docketsListParsed = docketService.parseDockets(returnData);
        for (var i = 0; i < docketsListParsed.length; i++) {
          $scope.itemEdit.dockets.push(docketsListParsed[i]);
        }
        cb();
      });
    }

    $scope.loadOrderJobs = function (order) {
      $scope.jobsPromise = $q(function (resolve, reject) {
        var params = [];
        params['limit'] = $scope.jobsQuery.limit;
        params['offset'] = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
        params['sort'] = $scope.jobsQuery.order;
        params['orderRef'] = order.id;

        jobService.getJobs(params, function (returnData) {
          var jobsListParsed = jobService.parseJobs(returnData);
          order.jobs = jobsListParsed;
          resolve('Done');
        }, function (err) {
          reject('Error');
        });
      });
    }

    $scope.$parent.loadOrderJobsNextPage = function (cb) {
      var offsetPre = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
      $scope.jobsQuery.page = $scope.jobsQuery.page + 1;
      var offset = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
      // get next page of dockets from docketService using pagination query params
      var params = [];
      params['limit'] = $scope.jobsQuery.limit;
      params['offset'] = $scope.jobsQuery.limit * ($scope.jobsQuery.page - 1);
      params['sort'] = $scope.jobsQuery.order;
      params['orderRef'] = $scope.itemEdit.id;

      jobService.getJobs(params, function (returnData) {
        var jobsListParsed = jobService.parseJobs(returnData);
        for (var i = 0; i < jobsListParsed.length; i++) {
          $scope.itemEdit.jobs.push(jobsListParsed[i]);
        }
        cb();
      });
    }

    /*****************************/
    /***** Main Ui Functions *****/
    /*****************************/

    /* Get Field Data */
    $scope.getFields = function () {
      docketService.getFields({}, function (fields) {
        $scope.allFields = {};
        for (var i = 0; i < fields.length; i++) {
          $scope.allFields[fields[i].id] = fields[i];
        }
      }, function (err) {
        $scope.allFields = {};
      });
    }
    $scope.getFields();

    $scope.matchCustomerContact = function (xeroContactId, cb) {
      if (!xeroContactId) {
        cb(null);
        return;
      }
      addressBookService.getAddressBook({ externalId: xeroContactId, externalIdType: 'xero' }, function (addressBook) {
        var matchedContact = null;
        if (addressBook[0] != null) {
          matchedContact = addressBook[0];
          cb(matchedContact);
          return;
        }

        cb(null);
        return;
      }, function (err) {
        console.error('could not get address book', err);
        cb(null);
        return;
      });
    }

    $scope.matchLineItems = function (xeroQuoteLineItems, cb) {
      if (!xeroQuoteLineItems || xeroQuoteLineItems.length <= 0) {
        cb(null);
        return;
      }

      var externalIdMaps = { "identifier": {}, "xero": {} };
      var matchedLines = [];


      var dbResources = []
      function getAllResources(offset, cb) {
        resourceService.getResources({ limit: 200, offset }, function (resources) {
          dbResources = dbResources.concat(resources)

          if (resources.length == 200) {
            getAllResources(offset + 200, cb)
          } else {
            cb()
          }
        })
      }

      getAllResources(0, function() {
        if (!dbResources || dbResources.length <= 0) {
          cb(null);
          return;
        }

        for (var i = 0; i < dbResources.length; i++) {
          if (dbResources[i].externalIdentifiers) {
            for (var j = 0; j < dbResources[i].externalIdentifiers.length; j++) {
              externalIdMaps[dbResources[i].externalIdentifiers[j].type][dbResources[i].externalIdentifiers[j].externalId] = dbResources[i];
            }
          }
          externalIdMaps["identifier"][dbResources[i].identifier] = dbResources[i];
        }

        for (var i = 0; i < xeroQuoteLineItems.length; i++) {
          if (externalIdMaps["identifier"][xeroQuoteLineItems[i].itemCode] != null) {
            var newLineItem = {};
            var resource = externalIdMaps["identifier"][xeroQuoteLineItems[i].itemCode];
            newLineItem.resource = resource;
            newLineItem.resourceCategory = resource.category.id;
            newLineItem.supplierRef = 'xql-' + xeroQuoteLineItems[i].lineItemID;
            newLineItem.quantity = parseFloat(xeroQuoteLineItems[i].quantity);
            newLineItem.quantityEdit = parseFloat(xeroQuoteLineItems[i].quantity);
            newLineItem.itemDescription = xeroQuoteLineItems[i].description;
            // TODO: add copy of externalID ref field and lineAmount field
            matchedLines.push(newLineItem);
          }
        }

        cb(matchedLines);
        return;
      });
    }

    $scope.newOrderFromXeroQuote = function (prefillData) {
      var newOrder = { 'status': 'New', 'newOrder': 'true' };
      if (prefillData.quoteNumber) {
        newOrder.supplierRefNo = 'xq_' + prefillData.quoteNumber + '_' + prefillData.quoteID;
        //newOrder.orderNumber = prefillData.quoteNumber;
      }
      // TODO: turn the below back on after externalID is setup to store quoteID reference
      /*if ( prefillData.referenceNumber ) {
        newOrder.supplierRefNo = prefillData.referenceNumber;
      }*/
      if (prefillData.dateString) {
        var startDate = moment(prefillData.dateString, 'YYYY-MM-DD').toDate();
        newOrder.startDate = startDate;
      } else {
        newOrder.startDate = moment().toDate();
      }
      if (prefillData.expiryDateString) {
        var endDate = moment(prefillData.expiryDateString, 'YYYY-MM-DD').toDate();
        newOrder.endDate = endDate;
      } else if (prefillData.dateString) {
        var endDate = moment(prefillData.dateString, 'YYYY-MM-DD').toDate();
        newOrder.endDate = endDate;
      } else {
        newOrder.endDate = moment().toDate();
      }
      if (prefillData.summary) {
        newOrder.notes = prefillData.summary;
      }

      // find xero contact
      $scope.matchCustomerContact(prefillData.contact.contactID, function (contact) {
        if (contact != null) {
          var customerContact = contact;
          if (customerContact.contactAddresses != null) {
            var newContactAddresses = {};
            for (var i = 0; i < customerContact.contactAddresses.length; i++) {
              newContactAddresses[customerContact.contactAddresses[i].emailAddress] = ['approver'];
            }

            customerContact.contactAddresses = newContactAddresses;
          }
          //TODO: setup default accessLevels for the contact
          newOrder.customerContact = customerContact;
        }

        $scope.matchLineItems(prefillData.lineItems, function (matchedLineData) {
          if (matchedLineData) {
            newOrder.lineItems = matchedLineData;
          }

          if (!matchedLineData || matchedLineData.length != prefillData.lineItems.length) {
            const missingItems = prefillData.lineItems.length - matchedLineData.length
            swal({
              title: "Not all Xero resources could be matched.",
              text: `${missingItems} line item${missingItems.length > 1 ? 's' : ''} from Xero could not be found in your resource list.`,
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Ok",
              closeOnConfirm: false
            })
          }

          var currentOrgGroup = $scope.currentOrgGroup;
          var currentOrg = $scope.currentOrg;

          // set supplier contact from this orgs details
          var supplierContact = {};
          supplierContact.displayName = currentOrgGroup.publicName;
          supplierContact.contactAddresses = {};
          supplierContact.addresses = [];
          if (currentOrgGroup.address != null) {
            supplierContact.addresses.push(currentOrgGroup.address);
          }
          if (currentOrgGroup.emailAddress != null) {
            supplierContact.contactAddresses[currentOrgGroup.emailAddress] = [];
          }
          newOrder.supplierContact = supplierContact;

          // set template
          if (currentOrgGroup.defaultTemplate != null) {
            var templateId = currentOrgGroup.defaultTemplate;
            // get template
            orderService.getTemplate(templateId, function (fullTemplate) {
              newOrder.template = fullTemplate;
              $scope.itemEdit = newOrder;
              $scope.itemEdit.editing = true;
              $scope.currentTab = "General";
            }, function (err) {
              newOrder.template = null;
              $scope.itemEdit = newOrder;
              $scope.itemEdit.editing = true;
              $scope.currentTab = "General";
            });
          } else {
            $scope.itemEdit = newOrder;
            $scope.itemEdit.editing = true;
            $scope.currentTab = "General";
          }
        });
      });
    }

    // New Order
    $scope.newOrder = function () {
      var newOrder = { 'status': 'New', 'orderNumber': 'New Order', 'newOrder': 'true', 'startDate': new Date(), 'endDate': new Date(), 'orderNumber': '' };
      var currentOrgGroup = $scope.currentOrgGroup;
      var currentOrg = $scope.currentOrg;

      // setup supplier contact from org group details
      var supplierContact = {};
      supplierContact.displayName = currentOrgGroup.publicName;
      supplierContact.contactAddresses = {};
      supplierContact.addresses = [];
      if (currentOrgGroup.address != null) {
        supplierContact.addresses.push(currentOrgGroup.address);
      }
      if (currentOrgGroup.emailAddress != null) {
        supplierContact.contactAddresses[currentOrgGroup.emailAddress] = [];
      }
      newOrder.supplierContact = supplierContact;

      if (currentOrgGroup.defaultTemplate != null) {
        var templateId = currentOrgGroup.defaultTemplate;
        // get template
        orderService.getTemplate(templateId, function (fullTemplate) {
          newOrder.template = fullTemplate;
          $scope.itemEdit = newOrder;
          $scope.updateTemplateFields($scope.itemEdit.template);
          $scope.itemEdit.editing = true;
          $scope.currentTab = "General";
        }, function (err) {
          newOrder.template = null;
          $scope.itemEdit = newOrder;
          $scope.itemEdit.editing = true;
          $scope.currentTab = "General";
        });
      } else {
        $scope.itemEdit = newOrder;
        $scope.itemEdit.editing = true;
        $scope.currentTab = "General";
      }
    }

    /***************************************/
    /***** Select Docket Template Func *****/
    /***************************************/

    $scope.assignTemplate = function (template, successCb) {
      if (template != null) {
        var unusableLineItems = templateIsUsable(template);
        if (unusableLineItems <= 0) {
          $scope.itemEdit.template = template;
          $scope.updateTemplateFields($scope.itemEdit.template);
          successCb()
        } else {
          var buttonActions = [{ title: 'Change Template', action: 'use', colour: 'grey' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Are you sure?', 'Some existing items on this order are not support by the selected docket template and may be unusable. Are you sure you want to use this template?', buttonActions, function (actionSelected) {
            if (actionSelected == 'use') {
              $scope.itemEdit.template = template;
              $scope.updateTemplateFields($scope.itemEdit.template);
              successCb()
            }
          });
        }
      }
    }

    // Select company - show list in sidebar
    $scope.selectDocketTemplate = function () {
      $scope.$parent.selectTemplateForOrder($scope.allTemplates, function (template) {
        $scope.assignTemplate(template, function () { });
      });
    }

    $scope.updateTemplateFields = function (template) {
      var fields = {};
      if (!template || !template.blocks) { return; }

      for (var i = 0; i < template.blocks.length; i++) {
        if (template.blocks[i].fields) {
          for (var j = 0; j < template.blocks[i].fields.length; j++) {
            fields[template.blocks[i].fields[j].id] = template.blocks[i].fields[j];
          }
        }
      }
      template.fields = fields;
    }

    var templateIsUsable = function (template) {
      var categories = [];
      for (var i = 0; i < template.interactionTemplates.length; i++) {
        for (var j = 0; j < template.interactionTemplates[i].actorCategories.length; j++) {
          if (categories.indexOf(template.interactionTemplates[i].actorCategories[j].id) == -1) {
            categories.push(template.interactionTemplates[i].actorCategories[j].id);
          }
        }
      }
      var unusableLineItems = [];
      if ($scope.itemEdit.lineItems) {
        for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
          var lineItem = $scope.itemEdit.lineItems[i];
          if (lineItem.resource && categories.indexOf(lineItem.resource.categoryId) == -1) {
            unusableLineItems.push(lineItem);
          }
        }
      }

      return unusableLineItems.length;
    }

    /****************************************/
    /***** Select Company Functionality *****/
    /****************************************/

    $scope.editOrderCustomer = function () {
      $scope.$parent.editContactForOrder($scope.itemEdit.customerContact, function (contactEdited) {
        if (contactEdited == 'select') {
          if ($scope.userCanDoAction('changeOrderCustomer', $scope.itemEdit)) {
            $scope.selectCompany('customerContact');
          }
        } else if (contactEdited != null) {
          $scope.itemEdit.customerContact = contactEdited;
        }
      });
    }

    // Select company - show list in sidebar
    $scope.selectCompany = function (type) {
      $scope.$parent.selectContactForOrder($scope.itemEdit, type, function (contact) {
        if (contact != null) {
          if (contact.contactAddresses != null) {
            var newContactAddresses = {};
            for (var i = 0; i < contact.contactAddresses.length; i++) {
              if (type == 'customerContact') {
                newContactAddresses[contact.contactAddresses[i].emailAddress] = ['approver'];
              } else {
                newContactAddresses[contact.contactAddresses[i].emailAddress] = ['editor'];
              }
            }

            contact.contactAddresses = newContactAddresses;
          }
          //TODO: setup default accessLevels for the contact
          $scope.itemEdit[type] = contact;
        }
      });
    }

    $scope.swapCustSup = function (order) {
      var customerContactCopy = angular.copy(order.customerContact);
      order.customerContact = order.supplierContact;
      order.supplierContact = customerContactCopy;

      if (order.customerContact) {
        var addressKeys = Object.keys(order.customerContact.contactAddresses);
        for (var i = 0; i < addressKeys.length; i++) {
          if (order.customerContact.contactAddresses[addressKeys[i]] == null || order.customerContact.contactAddresses[addressKeys[i]].length == 0) {
            order.customerContact.contactAddresses[addressKeys[i]] = ['approver'];
          }
        }
      }
    }

    /***********************************/
    /***** Line Item Functionality *****/
    /***********************************/

    $scope.newLineItem = function () {
      $scope.$parent.newLineItemForOrder($scope.itemEdit, function (item) {
        if (item != null) {
          // if time resource - format quantity from abbreviation to minutes
          if (item.resource) {
            if (item.resource.uom.isTime) {
              var abbreviation = item.resource.uom.abbreviation;
              if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
                // convert from hours to minutes
                item.quantity = item.quantityEdit * 60;
              }
              if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
                // display from hours&minutes to minutes
                var totalMinutes = 0;
                totalMinutes += parseInt(item.quantityHoursEdit) * 60;
                totalMinutes += parseInt(item.quantityMinutesEdit);
                item.quantity = totalMinutes;
              }
              if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
                item.quantity = item.quantityEdit;
              }
            } else {
              item.quantity = item.quantityEdit;
            }
          }

          item.edit = false;
          item.tempId = uuid.v4();
          if ($scope.itemEdit.lineItems == null) {
            $scope.itemEdit.lineItems = [];
          }
          $scope.itemEdit.lineItems.push(item);
        }
      });
    }


    const loadResources = function (allowedCategyIds, successCb) {

      if ($scope.currentOrg == null || $scope.currentOrgGroup == null) {
        return;
      }

      $scope.promise = $q(function (resolve, reject) {

        const promises = allowedCategyIds.map(categoryId =>
          $q(function (res) { resourceService.getResources({ categoryId }, res) }).then(function (val) { return val })
        )

        $q.all(promises).then(results => {
          var resourceSearchList = _.flatten(results)
          successCb(resourceSearchList)
          resolve('Done');
        })
      });
    }

    const manualSelectResourceForLine = function (lineItem, successCb) {
      var templateCategories = null;
      if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
        templateCategories = {};
        for (var i = 0; i < $scope.itemEdit.template.interactionTemplates.length; i++) {
          var interactionTemplate = $scope.itemEdit.template.interactionTemplates[i];
          for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
            if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
              templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
            }
          }
        }
      }
      var categories = [];
      for (var key in templateCategories) {
        categories.push(templateCategories[key]);
      }

      $scope.$parent.selectResourceForOrder({ multiple: false, categories: categories }, function (resources) {
        if (resources != null && resources[0] != null) {
          lineItem.resource = resources[0];
          if (successCb) {
            successCb();
          }
        }
      });
    }

    $scope.removeResourceForLine = function (lineItem) {
      lineItem.resource = null
    }

    $scope.selectResourceForLine = function (lineItem, successCb) {

      if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
        var allowedCategoryIds = _.uniq($scope.itemEdit.template.interactionTemplates.flatMap(iTemplate => iTemplate.actorCategories).map(actorCat => actorCat.id))
        loadResources(allowedCategoryIds, function (resources) {

          // Append string match to line item value
          resources.forEach(r => r.match = stringSimilarity.compareTwoStrings(r.name, lineItem.itemDescription));

          // Filter recommended resources
          var recommendedResources = _.sortBy(resources.filter(r => r.match >= 0.45 && allowedCategoryIds.includes(r.categoryId)), r => -r.match);

          if (recommendedResources.length > 0) {
            // Show recommendattion modal
            $scope.showRecommendLineItemResourceModal(lineItem, recommendedResources,
              function (selectedResource) {
                lineItem.resource = selectedResource;
                if (successCb) {
                  successCb();
                }
              },
              function () {
                manualSelectResourceForLine(lineItem, successCb);
              }
            )
          } else {
            manualSelectResourceForLine(lineItem, successCb);
          }
        })
      } else {
        manualSelectResourceForLine(lineItem, successCb);
      }
    }

    $scope.newLineItemDesktop = function () {
      if ($scope.userCanDoAction('isOrderSupplier', $scope.itemEdit)) {
        var templateCategories = null;
        if ($scope.itemEdit.template && $scope.itemEdit.template.interactionTemplates) {
          templateCategories = {};
          for (var i = 0; i < $scope.itemEdit.template.interactionTemplates.length; i++) {
            var interactionTemplate = $scope.itemEdit.template.interactionTemplates[i];
            for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
              if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
                templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
              }
            }
          }
        }
        var categories = [];
        for (var key in templateCategories) {
          categories.push(templateCategories[key]);
        }
        $scope.$parent.selectResourceForOrder({ multiple: true, categories: categories }, function (resources) {
          if (resources != null) {
            if ($scope.itemEdit.lineItems == null) {
              $scope.itemEdit.lineItems = [];
            }

            for (var i = 0; i < resources.length; i++) {
              if ($scope.currentOrg.features && $scope.currentOrg.features.xero && $scope.currentOrg.features.xero.quotesEnabled) {
                var xeroExternalId = null;
                var preCreatedSupplierRef = null;
                if (resources[i].externalIdentifiers) {
                  for (var j = 0; j < resources[i].externalIdentifiers.length; j++) {
                    if (resources[i].externalIdentifiers[j].type == 'xero') {
                      xeroExternalId = resources[i].externalIdentifiers[j].externalId;
                      break;
                    }
                  }
                  if (xeroExternalId) {
                    preCreatedSupplierRef = 'xi-' + xeroExternalId;
                  }
                }
                $scope.itemEdit.lineItems.push({ resource: resources[i], quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "", supplierRef: preCreatedSupplierRef });
              } else {
                $scope.itemEdit.lineItems.push({ resource: resources[i], quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "", supplierRef: '' });
              }
            }
          }
        });
      } else {
        if ($scope.itemEdit.lineItems == null) {
          $scope.itemEdit.lineItems = [];
        }
        $scope.itemEdit.lineItems.push({ quantity: 0, quantityEdit: 0, quantityHoursEdit: 0, quantityMinutesEdit: 0, itemDescription: "" });
      }
    }

    $scope.editLineItem = function (item) {
      //if ( $scope.itemEdit.status != 'Draft' && !item.new ) {
      //item.readOnly = true;
      //}
      // if time resource - format quantity as per abbreviation
      if (item.new != true && item.resource && item.resource.uom.isTime) {
        var quantity = item.quantity;
        var abbreviation = item.resource.uom.abbreviation;
        if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
          // display as hours
          item.quantityEdit = quantity / 60;
          item.quantityEditType = 'h';
        }
        if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
          // display as hours and minutes
          var hours = Math.floor(quantity / 60);
          var minutes = quantity % 60;
          item.quantityHoursEdit = hours;
          item.quantityMinutesEdit = minutes;
          item.quantityEditType = 'hm';
        }
        if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
          item.quantityEdit = quantity;
          item.quantityEditType = 'm';
        }
      } else {
        item.quantityEdit = item.quantity;
        item.quantityEditType = 'normal';
      }

      if (item.new != true && item.resource != null) {
        item.resourceLocked = true;
      }
      $scope.$parent.editLineItemForOrder($scope.itemEdit, item, function (item) {
        if (item != null) {
          // if time resource - format quantity from abbreviation to minutes
          if (item.resource.uom.isTime) {
            var abbreviation = item.resource.uom.abbreviation;
            if (abbreviation == 'h' || abbreviation == 'H' || abbreviation == 'hours' || abbreviation == 'hrs') {
              // convert from hours to minutes
              item.quantity = item.quantityEdit * 60;
            }
            if (abbreviation == 'hm' || abbreviation == 'HM' || abbreviation == 'hoursminutes' || abbreviation == 'hrsmins') {
              // display from hours&minutes to minutes
              var totalMinutes = 0;
              totalMinutes += parseInt(item.quantityHoursEdit) * 60;
              totalMinutes += parseInt(item.quantityMinutesEdit);
              item.quantity = totalMinutes;
            }
            if (abbreviation == 'm' || abbreviation == 'M' || abbreviation == 'minutes' || abbreviation == 'mins') {
              item.quantity = item.quantityEdit;
            }
          } else {
            item.quantity = item.quantityEdit;
          }

          item.edit = false;
        }
      });
    }

    $scope.removeLineItem = function (lineItem) {
      var buttonActions = [{ title: 'Delete Order Line', action: 'use', colour: 'green' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
      $scope.alertService.presentConfirmAlert('Are you sure?', 'Removing this line item from the order cannot be undone.', buttonActions, function (actionSelected) {
        if (actionSelected == 'use') {
          if (lineItem.id) {
            lineItem.delete = true;
          } else {
            var index = $scope.itemEdit.lineItems.indexOf(lineItem);
            if (index != -1) {
              $scope.itemEdit.lineItems.splice(index, 1);
            }
          }
        }
      });
    }

    /*********************************/
    /**** Access Control Editing *****/
    /*********************************/

    $scope.assignOrderOrg = function (order) {
      var assignOrder = {};
      $scope.$parent.selectOrganisationForOrder(order, function (group) {
        if (group != null) {
          $scope.assignOrderSave(order, group);
        }
      });
    }

    $scope.assignOrderSave = function (order, group) {
      var losingPrincipal = $scope.currentUser.emailAddress;
      var gainingPrincipal = group.emailAddress;
      orderService.reassignOrder(order.id, losingPrincipal, gainingPrincipal, function (success) {
        $scope.$parent.closeOrder();
        if ($stateParams.device == 'desktop') {
          $scope.$parent.loadOrdersList();
        }
      }, function (err) {
        swal({
          title: "Error!",
          text: "An error occured while reassigning the order.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }

    /*************************************/
    /***** Share Order Functionality *****/
    /*************************************/

    $scope.shareOrder = function (order) {
      var userAccessLevels = [];
      $scope.newAccessor = { 'accessLevel': 'viewer' };
      $scope.accessControlEdit = {};
      $scope.accessControlEdit.orderNumber = order.orderNumber;
      var accessControlEdit = [];
      var currentKeys = Object.keys(order.accessControl);
      for (var i = 0; i < currentKeys.length; i++) {
        var newAccessControlItem = {};
        newAccessControlItem.emailAddress = currentKeys[i];
        newAccessControlItem.accessLevel = "";
        if (order.accessControl[currentKeys[i]].indexOf('creator') != -1) {
          newAccessControlItem.accessLevel = 'creator';
          newAccessControlItem.accessLevelSet = true;
        } else if (order.accessControl[currentKeys[i]].indexOf('supplier') != -1) {
          newAccessControlItem.accessLevel = 'supplier';
        } else if (order.accessControl[currentKeys[i]].indexOf('customer') != -1) {
          newAccessControlItem.accessLevel = 'customer';
        } else if (order.accessControl[currentKeys[i]].indexOf('viewer') != -1) {
          newAccessControlItem.accessLevel = 'viewer';
        }
        newAccessControlItem.accessLevelInitial = newAccessControlItem.accessLevel;
        newAccessControlItem.accessLevelsArray = order.accessControl[currentKeys[i]];

        // check if current user and get accessLevels
        if (newAccessControlItem.emailAddress == $scope.currentUser.emailAddress) {
          for (var j = 0; j < newAccessControlItem.accessLevelsArray.length; j++) {
            userAccessLevels.push(newAccessControlItem.accessLevelsArray[j]);
          }
          newAccessControlItem.isUser = true;
        }

        // check is current org groups email and add get accessLevels
        if ($scope.currentOrgGroup && $scope.currentOrgGroup.emailAddresses) {
          for (var j = 0; j < $scope.currentOrgGroup.emailAddresses.length; j++) {
            if ($scope.currentOrgGroup.emailAddresses[j] == newAccessControlItem.emailAddress) {
              for (var k = 0; k < newAccessControlItem.accessLevelsArray.length; k++) {
                userAccessLevels.push(newAccessControlItem.accessLevelsArray[k]);
              }
              break;
            }
          }
        }
        accessControlEdit.push(newAccessControlItem);
      }

      $scope.accessControlEdit.accessControl = accessControlEdit;

      // get max accessLevel
      var maxLevel = "";
      if (userAccessLevels.indexOf('creator') != -1) {
        maxLevel = "creator";
      } else if (userAccessLevels.indexOf('supplier') != -1) {
        maxLevel = "supplier";
      } else if (userAccessLevels.indexOf('customer') != -1) {
        maxLevel = "customer";
      } else if (userAccessLevels.indexOf('viewer') != -1) {
        maxLevel = "viewer";
      }
      $scope.accessControlEdit.maxLevel = maxLevel;
      $mdBottomSheet.hide();
      $("#shareOrderModal").fadeIn(100);
    }

    $scope.canSetAccessLevel = function (accessor, accessLevel) {
      if (!$scope.accessControlEdit || !$scope.accessControlEdit.maxLevel) {
        return false;
      }
      if (accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' ||
        $scope.accessControlEdit.maxLevel == 'supplier' || $scope.accessControlEdit.maxLevel == 'customer' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessLevel == 'remove' && accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }

      return false;
    }

    $scope.canChangeAccessLevel = function (accessor) {
      if (accessor.accessLevel == 'viewer' && ($scope.accessControlEdit.maxLevel == 'viewer' ||
        $scope.accessControlEdit.maxLevel == 'creator')) {
        return true;
      }
      if (accessor.accessLevel == 'creator' && $scope.accessControlEdit.maxLevel == 'creator') {
        return true;
      }
    }

    $scope.closeAccessControlModal = function () {
      $("#shareOrderModal").fadeOut(100);
    }

    $scope.saveAccessControlEdit = function () {
      $scope.accessControlEdit.loading = true;
      // convert back to accessControl object
      var accessControlObject = {};
      for (var i = 0; i < $scope.accessControlEdit.accessControl.length; i++) {
        var thisAccessItem = $scope.accessControlEdit.accessControl[i];
        if (thisAccessItem.new == true) {
          accessControlObject[thisAccessItem.emailAddress] = {};
          accessControlObject[thisAccessItem.emailAddress].add = [thisAccessItem.accessLevel];
        } else if (thisAccessItem.accessLevelInitial != thisAccessItem.accessLevel) {
          // access has been changed - need to construct add/remove fields
          if (thisAccessItem.accessLevel == 'remove') {
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
          } else if (thisAccessItem.accessLevel == 'viewer') {
            // construct ad/remove dependent on initial array
            accessControlObject[thisAccessItem.emailAddress] = {};
            accessControlObject[thisAccessItem.emailAddress].remove = thisAccessItem.accessLevelsArray;
            accessControlObject[thisAccessItem.emailAddress].add = ['viewer'];
          }
        }
      }

      orderService.updateAccessControl($scope.itemEdit.id, accessControlObject, function (success) {
        $scope.itemEdit.accessControl = success.accessControl;
        $("#shareOrderModal").fadeOut(100);
      }, function (err) {
        $scope.accessControlEdit.loading = false;
        swal({
          title: "Error!",
          text: "An error occured while sharing the order.",
          type: "error",
          confirmButtonText: "Ok, got it."
        });
      });
    }

    $scope.addNewAccessor = function () {
      if ($scope.newAccessor.emailAddress != "") {
        $scope.newAccessor.new = true;
        var emailAddresses = $scope.newAccessor.emailAddress.split(',');
        if (emailAddresses.length > 1) {
          for (var i = 0; i < emailAddresses.length; i++) {
            var newAccessor = angular.copy($scope.newAccessor);
            newAccessor.emailAddress = emailAddresses[i];
            $scope.accessControlEdit.accessControl.push(newAccessor);
          }
        } else {
          $scope.accessControlEdit.accessControl.push($scope.newAccessor);
        }
        $scope.newAccessor = { 'accessLevel': 'viewer' };
      }
    }

    $scope.selectAccessorContact = function () {
      $("#shareOrderModal").fadeOut(100);
      $scope.$parent.selectContactForShare(function (contactSelected) {
        if (contactSelected != null) {
          $("#shareOrderModal").fadeIn(100);
          /*if ( contactSelected.contactAddresses && contactSelected.contactAddresses[0].emailAddress ) {
            $scope.newAccessor.emailAddress = contactSelected.contactAddresses[0].emailAddress;
          }*/
          var emailAddresses = [];
          for (var i = 0; i < contactSelected.contactAddresses.length; i++) {
            if (contactSelected.contactAddresses[i].emailAddress) {
              emailAddresses.push(contactSelected.contactAddresses[i].emailAddress);
            }
          }
          $scope.newAccessor.emailAddress = emailAddresses.join(',');
        } else {
          $("#shareOrderModal").fadeIn(100);
        }
      });
    }


    /***********************************/
    /**** Order Line Reassignment ******/
    /***********************************/

    $scope.reassignOrderLine = function (lineItem) {
      $scope.orderLineSelectFromParentAdvanced($scope.itemEdit.lineItems, lineItem, function (lineItemSelected) {
        if (lineItemSelected) {
          var fullMessage = "All dockets associated with the order line item '" + lineItem.itemDescription + "' will be relinked to the order line item '" + lineItemSelected.itemDescription + "'. This operation cannot be reverted.";
          var buttonActions = [{ title: 'Continue', action: 'use', colour: 'green' }, { title: "Cancel", action: 'dontUse', colour: 'grey' }];
          $scope.alertService.presentConfirmAlert('Confirm Order Line Reassignment', fullMessage, buttonActions, function (actionSelected) {
            if (actionSelected == 'use') {
              orderService.reassignOrderLineItems($scope.itemEdit, lineItem, lineItemSelected, function (success) {
                $timeout(function () {
                  $scope.alertService.presentAlert('success', 'Order Line Reassigned', 'All dockets associated with this order line change are being updated - this can take a few minutes.');
                  // alert about scheduled job
                  if (!lineItemSelected.resource) {
                    for (var i = 0; i < $scope.itemEdit.lineItems.length; i++) {
                      if ($scope.itemEdit.lineItems[i].id == lineItemSelected.id) {
                        $scope.itemEdit.lineItems[i].resource = lineItem.resource;
                        $scope.itemEdit.lineItems[i].quantity = lineItem.quantity;
                        $scope.itemEdit.lineItems[i].uom = lineItem.uom;
                      }
                    }
                  }
                  lineItem.resource = null
                }, 1000);
              }, function (err) {
                console.error('could not reassign order line', err);
              });
            }
          });
        }
      });
    }

    $scope.canDeleteOrderLineItem = function (order) {
      var hasCreator = false;
      for (var i = 0; i < $scope.currentOrgGroup.emailAddresses.length; i++) {
        if (order.accessControl[$scope.currentOrgGroup.emailAddresses[i]].indexOf('creator') != -1) {
          hasCreator = true;
          break;
        }
      }

      return hasCreator;
    }

    /************************************/
    /***** General UI Functionality *****/
    /************************************/

    $scope.openMobileTab = function (tabName) {
      $scope.currentTab = tabName;
      var leftOffset = $("#tab" + tabName).offset().left + $("#tab" + tabName).width();
      var width = $(".tabBarMobile.detailTabBar").width();
      var M = width / 2;
      var Y = leftOffset;
      var X = $(".tabBarMobile.detailTabBar").scrollLeft();

      if (Y > M) {
        // scroll right
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X + (Y - M) }, 600);
      } else {
        // scroll left
        $(".tabBarMobile.detailTabBar").animate({ scrollLeft: X - (M - Y) }, 600);
      }
    }

    $scope.compIsCurrentOrgGroup = function (companyId) {
      if ($scope.currentOrgGroup.id == companyId) {
        return true;
      } else {
        return false;
      }
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

    /***********************/
    /**** Bottom Sheet *****/
    /***********************/

    $scope.openBottomSheet = function () {
      $mdBottomSheet.show({
        templateUrl: 'views/pages/orders/mobile/ordersBottomSheet.html',
        scope: $scope,
        preserveScope: true
      }).then(function () {

      });
    }

    /*****************************/
    /***** Date/Time Pickers *****/
    /*****************************/

    $scope.showDatePicker = function (field, ev) {
      $mdpDatePicker($scope.itemEdit[field], {
        targetEvent: ev
      }).then(function (selectedDate) {
        $scope.itemEdit[field] = selectedDate;
      });
    }

    $scope.showTimePicker = function (field, ev) {
      $mdpTimePicker($scope.itemEdit[field], {
        targetEvent: ev,
        autoSwitch: true
      }).then(function (selectedTime) {
        $scope.itemEdit[field] = selectedTime;
      });
    }

    /**********************************/
    /**** Alert Parent Controller *****/
    /**********************************/

    $scope.$parent.detailControllerReady();

  });



// WEBPACK FOOTER //
// ./src/controllers/orders/detailController.js